import {API_URL} from "../../manufacurs/manufactury-list/core/_requests";
import axios from "axios";
import {TicketContentModel, TicketModel} from "./_model";
import {ID, Response} from "../../../../_metronic/helpers";
const USER_URL = `${API_URL}/api/v3/TicketV`
const DownloadAttachment = (TicketId: ID,fileName : string) => {

    axios.get(`${USER_URL}/DownloadAttachment/${TicketId}/${fileName}`, {
        responseType :'blob',
        onDownloadProgress: progressEvent => {
            // let percentCompleted = Math.round(
            //     (progressEvent.loaded * 100) / progressEvent.total
            // );
            // console.log('completed: ', percentCompleted)
        }
    })
        .then(res => {
            const link = document.createElement("a");
            link.target = "_blank";
            link.download = fileName
            link.href = URL.createObjectURL(
                new Blob([res.data], { type: 'application/octet-stream' })
            );
            link.click();
        })
        .catch((error) => {
            console.log(error);
        })

}
const AddMessage = (id:ID ,obj : any) =>{
    const fd = new FormData();
    fd.append('Text', obj.text);
    if(obj.file){
        fd.append('File', obj.file,obj.file.name);
    }

    return axios.post<TicketContentModel>(`${USER_URL}/AddMessage/${id}`,fd)
}
const PostTicket = (obj : any) =>{
    const fd = new FormData();
    fd.append('Text', obj.text);
    fd.append('Title', obj.title);
    if(obj.file){
        fd.append('File', obj.file,obj.file.name);
    }

    return axios.post<TicketModel>(`${USER_URL}`,fd)
}
const GetTicketMessage = (id : number) =>{
    return axios.get<TicketContentModel[]>(`${USER_URL}/GetTicketContent/${id}`)
}
const GetTicket = (query : string) =>{
    return axios.get<Response<TicketModel[]>>(`${USER_URL}/Get?${query}`)
}


export {DownloadAttachment,PostTicket,GetTicket,GetTicketMessage,AddMessage}